import Alert from "features/shared/alerts/components/Alert";
import IDataFilterHandler from "features/shared/components/dataFilter/IDataFilterHandler";
import { DataGridId } from "features/shared/components/dataGrid/DataGridId";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import IAppState from "infrastructure/store/IAppState";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const ConsumptionHistoryNoContentAlert = () => {
  // translations
  const tShared = useTranslation("shared\\components").t;
  const tLabels = useTranslation("consumption\\consumption").t;

  // DI
  const _dataFilterHandler = useInjection<IDataFilterHandler>(
    IocTypes.DataFilterHandler
  );

  // store
  const consumptionFilterParams = useSelector<IAppState, string | undefined>(
    (state) =>
      state.dataGrid.gridSettings[DataGridId.consumptionHistoryGrid]
        ?.filtrUrlSearchParams
  );

  // handlers
  const resetFilterHandler = () => {
    _dataFilterHandler.storeResetDataGridSettings(
      DataGridId.consumptionHistoryGrid
    );
  };

  // render
  if (
    consumptionFilterParams &&
    consumptionFilterParams.includes("CommodityDetail")
  ) {
    return (
      <Alert alertObj={{ alertType: "Info" }}>
        <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">
          <span className="mr-2 mb-2 mb-sm-0">
            {tLabels("consumptionHistoryNoContentAlert.commodityAlert")}
          </span>
          <button
            className="btn btn-sm btn-info"
            onClick={resetFilterHandler}
          >
            {tLabels("consumptionHistoryNoContentAlert.resetFilter")}
          </button>
        </div>
      </Alert>
    );
  } else {
    return (
      <Alert
        alertObj={{
          alertType: "Info",
          message: tShared("noContentWrapper.noContent"),
        }}
      />
    );
  }
};

export default ConsumptionHistoryNoContentAlert;
